<template>
  <div class="holder">
    <div class='two_column_layout' id="scroll-direction">
    <form
      ref="form"
      @submit.prevent="validate"
      class="form-container"
    >
      <input type="hidden" name="contactKey"/>
      <div class="form__container">
        <div class="form">
          <div class="form__body">
            <div class="form__content full-width flex">
              <h2 class="xlarge-body">
                <b>Personal informations</b>
              </h2>
              <p class="smallst">
                * Required field
              </p>
            </div>
            <div class="form__row" v-for="row in personalFieldsRows" :key="row">
              <component :is="field.component" v-for="field in row" :ref="field.name" :key="field.name" @passValue="callback" :field="field"/>
            </div>
          </div>
        </div>
        <div class="form__actions">
          <button type="submit" class="button button--basic background--accent">
            <span class="button__inner">
              <span class="button__icon">
                <svg viewBox="0 0 16 14">
                  <g fill-rule="nonzero">
                    <path
                      d="M13.566 6.125H.71a.625.625 0 00-.625.625v.5c0 .345.28.625.625.625h12.856c.345 0 .625-.28.625-.625v-.5a.625.625 0 00-.625-.625z"
                    ></path>
                    <path
                      d="M15.025 6.548l-4.87-5.288-.037-.036a.625.625 0 00-.883.036l-.312.338a.625.625 0 000 .847l4.871 5.288.036.036c.254.234.65.218.884-.036l.311-.338a.625.625 0 000-.847z"
                    ></path>
                    <path
                      d="M13.794 6.262L8.923 11.55a.625.625 0 000 .847l.33.357.018.017c.253.234.649.218.883-.036l4.87-5.288a.625.625 0 000-.847l-.329-.356-.018-.018a.625.625 0 00-.883.036z"
                    ></path>
                  </g>
                </svg>
              </span>
              <span class="button__text">Copy signature</span>
            </span>
          </button>
          <span v-if="copied">&nbsp;Copied to clipboard!</span>
        </div>
      </div>
    </form>
    <div class="contact__side background--light" data-scroll data-scroll-sticky data-scroll-target="#scroll-direction">
      <!-- actual signature -->
      <p class="spec">Create your personal Growing Minds email signature 🥳. Enter your details in the form on the left and copy paste the signature in your favourite email client.</p>
      <table ref="element">

        <p style="-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; letter-spacing: -.4px; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 13px; line-height: 16px; color: #1C1E25; font-weight: 700; margin-top: 24px; margin-bottom: 12px;">{{ fieldnames.firstname }}<span v-if="fieldnames.suffix">&nbsp;{{ fieldnames.suffix }}</span> {{ fieldnames.lastname }}<br /><span style="color: #85969C; font-weight: 400; font-size: 13px; letter-spacing: 0px;">{{ fieldnames.jobtitle }}</span></p>

        <table id="gmHolder" cellspacing='0' cellpadding="0" border-spacing="0" style="margin: 0; padding: 0; margin-bottom: 12px;">
          <tr>
            <td width="153" height="20" valign="top" style="width: 153px; height: 20px; margin: 0; padding: 12px; background-color: #4160FF;">
              <a href="https://www.growingmindsagency.com/" title="Growing Minds" style="border: none; text-decoration: none; background-color: transparent; display: block; width: 153px; height: 20px;">
                <img moz-do-not-send="true" src="https://growingmindsagency.com/email/logo.png" width="153" alt="Growing Minds - Salesforce Marketing Cloud Agency" style="display: block; border: 0px; outline: none; width: 100%; height: auto; max-width: 153px;" />
              </a>
            </td>
          </tr>
        </table>

        <p style="-webkit-font-smoothing: antialiased; -moz-osx-font-smoothing: grayscale; letter-spacing: -.3px; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 11px; line-height: 18px; color: #1C1E25; font-weight: 400; margin-bottom: 12px;">
          <a style="text-decoration: none; color: #1C1E25;" :href="'mailto:'+fieldnames.email"><span style="text-decoration: none; white-space: nowrap; font-size: 11px; color: #1C1E25;">{{ fieldnames.email }} </span></a>
          <span style="color: #4160FF; font-size: 11px;">&nbsp;|&nbsp;</span>
          <span v-if="fieldnames.phone" style="text-decoration: none; white-space: nowrap; font-size: 11px; padding-left: 4px;">{{ fieldnames.phone }}&nbsp;<span style="color: #4160FF; font-size: 11px;">&nbsp;|&nbsp;</span></span>
          <a href="https://www.growingminds.nl/" style="text-decoration: none; white-space: nowrap; font-size: 11px;"><span style="color: #1C1E25">growingminds.nl</span></a><br>
          <a href="https://goo.gl/maps/h3tC4wAa7wrX2HfeA" style="text-decoration: none; white-space: nowrap; font-size: 11px;"><span style="color: #85969C; font-size: 11px;">Wibautstraat 135–139, 1097 DN Amsterdam</span></a>
          <span style="color: #85969C; font-size: 11px;">&nbsp;|&nbsp;</span>
          <a href="tel:+ (31) 020-3300881" style="text-decoration: none; white-space: nowrap; font-size: 11px;"><span style="color: #85969C">(+31) 2 033 008 81</span></a><br>
          <span v-if="fieldnames.workdays" style="color: #85969C; display: table-cell; padding-top: 12px; font-size: 11px;">I’m not available on: {{ fieldnames.workdays }}</span>
        </p>

        <table id="socialHolder" cellspacing='0' cellpadding="0" border-spacing="0" style="margin: 0; padding: 0; margin-bottom: 16px;">
          <tr>
            <td width="26" height="26" valign="top" style="width: 26px; height: 26px; margin: 0px; padding: 0px;">
              <a href="https://www.linkedin.com/company/growing-minds/" title="LinkedIn Growing Minds" style="border: none; text-decoration: none; background-color: transparent; display: block; width: 26px; height: 26px;">
                <img moz-do-not-send="true" src="https://growingmindsagency.com/email/li.png" width="26" alt="LinkedIn Growing Minds" style="display: block; border: 0px; outline: none; width: 100%; height: auto; max-width: 26px;" />
              </a>
            </td>
            <td width="8" height="26" valign="top"></td>
            <td width="26" height="26" valign="top" style="width: 26px; height: 26px; margin: 0px; padding: 0px;">
              <a href="https://www.instagram.com/_growingminds/" title="Instagram Growing Minds" style="border: none; text-decoration: none; background-color: transparent; display: block; width: 26px; height: 26px;">
                <img moz-do-not-send="true" src="https://growingmindsagency.com/email/ig.png" width="26" alt="Instagram Growing Minds" style="display: block; border: 0px; outline: none; width: 100%; height: auto; max-width: 26px;" />
              </a>
            </td>
          </tr>
        </table>


        <br />
      </table>
    </div>
  </div>
  <footer
    class="footer color--light"
  >
    <div class="footer__bottom font-medium xsmall-body">
      <div class="footer__left">
        <a href="mailto:info@growingminds.nl">info@growingminds.nl</a>
        <span>|</span>
        <a href="tel:020 – 330 08 81">(+31) 20 330 08 81</a>
        <span>|</span>
        <address>Wibautstraat 135-139, 1097 DN Amsterdam</address>
      </div>
      <div class="socials">
        <a
          class="socials__item"
          href="https://www.instagram.com/_growingminds/"
        >
          <svg viewBox="0 0 20 20">
            <path
              d="M9.999 1.782c2.673 0 2.97 0 3.96.099.99 0 1.485.198 1.88.297.496.198.793.396 1.09.693.396.396.594.693.693 1.089.099.396.297.89.297 1.88 0 1.09.099 1.387.099 3.96 0 2.674 0 2.97-.1 3.96 0 .99-.197 1.486-.296 1.882-.198.495-.396.792-.693 1.089-.297.297-.693.594-1.09.693-.395.099-.89.297-1.88.297-1.09 0-1.386.099-3.96.099-2.673 0-2.97 0-3.96-.1-.99 0-1.485-.197-1.881-.296-.495-.198-.792-.396-1.09-.693-.296-.396-.593-.693-.692-1.09-.1-.395-.297-.89-.297-1.88 0-1.09-.1-1.386-.1-3.96 0-2.673 0-2.97.1-3.96 0-.99.198-1.485.297-1.881.198-.495.396-.792.693-1.09.297-.395.693-.593 1.089-.692.396-.1.89-.297 1.88-.297.99-.099 1.288-.099 3.96-.099m0-1.782C7.327 0 6.93 0 5.94.099c-1.09 0-1.782.198-2.376.495-.693.297-1.188.594-1.782 1.188-.594.594-.891 1.089-1.188 1.782A10.942 10.942 0 00.099 5.94C.099 7.029 0 7.326 0 9.999s0 3.069.099 4.059c0 1.089.198 1.782.495 2.376.297.693.594 1.188 1.188 1.781.594.594 1.089.891 1.782 1.188.594.198 1.386.396 2.376.495 1.089 0 1.386.1 4.059.1s3.069 0 4.059-.1c1.089 0 1.782-.198 2.376-.495.693-.297 1.188-.594 1.781-1.188.594-.593.891-1.088 1.188-1.781.198-.594.396-1.386.495-2.376 0-1.09.1-1.386.1-4.06 0-2.672 0-3.068-.1-4.058 0-1.09-.198-1.782-.495-2.376-.297-.693-.594-1.188-1.188-1.782-.593-.594-1.088-.891-1.781-1.188a10.942 10.942 0 00-2.376-.495C13.068 0 12.672 0 9.998 0"
            ></path>
            <path
              d="M9.999 4.95c-2.772 0-5.05 2.277-5.05 5.049 0 2.772 2.278 5.049 5.05 5.049s5.049-2.277 5.049-5.05c0-2.771-2.277-5.048-5.05-5.048m0 8.316c-1.781 0-3.266-1.485-3.266-3.267 0-1.782 1.485-3.267 3.267-3.267 1.782 0 3.267 1.485 3.267 3.267 0 1.782-1.485 3.267-3.267 3.267M16.236 5.148c0 .693-.495 1.188-1.188 1.188S13.86 5.84 13.86 5.148s.495-1.188 1.188-1.188 1.188.495 1.188 1.188"
            ></path>
          </svg>
          <span class="sr-only"> instagram </span>
        </a>
        <a class="socials__item" href="https://www.facebook.com/GrowingM">
          <svg viewBox="0 0 20 20">
            <path
              fill-rule="nonzero"
              d="M18.9 0H1.1C.5 0 0 .5 0 1.1v17.8c0 .6.5 1.1 1.1 1.1h9.6v-7.7H8.1v-3h2.6V7c0-2.6 1.6-4 3.9-4 1.1 0 2.1.1 2.3.1v2.7h-1.6c-1.3 0-1.5.6-1.5 1.5v1.9h3l-.4 3h-2.6V20h5.1c.6 0 1.1-.5 1.1-1.1V1.1c0-.6-.5-1.1-1.1-1.1z"
            ></path>
          </svg>
          <span class="sr-only"> facebook </span>
        </a>
      </div>
      <a
        class="footer__logo"
        href="http://growingminds-staging.flywheelsites.com/"
      >
        <svg viewBox="0 0 139 40">
          <path
            fill-rule="nonzero"
            d="M108.938 27.26c1.416 0 2.575.364 3.477 1.09.901.727 1.384 1.695 1.448 2.904h-2.704l-.033-.176a1.837 1.837 0 00-.716-1.098 2.295 2.295 0 00-1.4-.466c-.531 0-.958.119-1.28.355-.322.237-.483.56-.483.968 0 .36.125.637.375.833.25.196.571.335.965.417.395.081.833.147 1.316.196a9.03 9.03 0 011.45.27c.482.13.92.318 1.315.563.395.245.717.624.966 1.139.25.514.374 1.147.374 1.899 0 1.16-.43 2.09-1.292 2.793-.86.702-2 1.053-3.416 1.053-1.481 0-2.676-.388-3.586-1.164-.91-.776-1.396-1.825-1.46-3.148h2.704l.028.191c.092.499.324.9.696 1.206.418.343.958.514 1.618.514.563 0 1.026-.127 1.388-.38.362-.253.543-.567.543-.943 0-.425-.165-.755-.495-.992-.33-.237-.74-.388-1.231-.453a15.993 15.993 0 01-1.606-.307 11.655 11.655 0 01-1.605-.502c-.491-.196-.902-.555-1.232-1.078-.33-.523-.495-1.192-.495-2.009 0-1.078.415-1.96 1.244-2.646.829-.686 1.87-1.029 3.127-1.029zm-6.254-5.096v17.64h-2.946v-1.543l-.14.196c-.34.447-.784.806-1.333 1.078a4.568 4.568 0 01-2.053.465c-1.803 0-3.22-.584-4.25-1.752-1.03-1.168-1.545-2.707-1.545-4.618 0-1.91.515-3.45 1.546-4.618 1.03-1.168 2.43-1.752 4.201-1.752 1.594 0 2.785.564 3.574 1.69v-6.786h2.946zM31.997 0c.697 0 1.34.383 1.688 1.004l10.057 18a2.048 2.048 0 010 1.992l-10.057 18A1.938 1.938 0 0131.997 40h-9.074a.987.987 0 01-.973-1V1c0-.552.436-1 .973-1h9.074zm52.48 27.26c1.368 0 2.467.453 3.296 1.36.83.906 1.244 2.086 1.244 3.54v7.644h-2.97v-7.007l-.007-.25c-.042-.736-.273-1.342-.694-1.82-.466-.531-1.078-.796-1.835-.796-.837 0-1.517.294-2.04.882-.523.588-.785 1.339-.785 2.254v6.737h-2.97V27.456h2.97v1.911l.105-.196c.725-1.274 1.954-1.91 3.686-1.91zm-8.813.196v12.348h-2.97V27.456h2.97zm-19.221-4.802l5.119 12.667 5.12-12.667h3.67v17.15h-2.995V28.436L62.77 39.804h-2.414l-4.612-11.368v11.368h-2.994v-17.15h3.694zm40.204 7.203c-.998 0-1.795.343-2.39 1.03-.596.685-.894 1.6-.894 2.743 0 1.143.298 2.058.893 2.744.596.686 1.393 1.029 2.391 1.029s1.795-.343 2.39-1.029c.596-.686.894-1.6.894-2.744 0-1.143-.298-2.058-.894-2.744-.595-.686-1.392-1.029-2.39-1.029zM15.466 5.026c.498 0 .909.386.965.885l.006.116v28.048a.992.992 0 01-.858.995l-.113.007h-6.27c-.643 0-1.24-.327-1.6-.867l-.086-.14L.258 21.047a2.058 2.058 0 01-.08-1.834l.078-.157 7.218-13.02A1.94 1.94 0 019 5.032l.16-.006h6.305zM75.76 22.654v2.99h-3.187v-2.99h3.187zm56.72-17.852c.757 0 1.45.143 2.077.429.628.286 1.119.673 1.473 1.163V4.998H139v13.034l-.006.255c-.052 1.173-.468 2.13-1.25 2.869-.837.792-1.94 1.188-3.308 1.188h-6.012v-2.401h5.602l.194-.008c.508-.04.93-.242 1.267-.605.378-.408.567-.939.567-1.592v-1.764l-.122.173c-.305.394-.74.716-1.303.966a5.119 5.119 0 01-2.1.429c-1.803 0-3.22-.584-4.25-1.752-1.03-1.168-1.545-2.707-1.545-4.618 0-1.911.51-3.45 1.533-4.618 1.022-1.168 2.427-1.752 4.213-1.752zM60.451 0c2.077 0 3.807.56 5.192 1.678 1.384 1.12 2.14 2.569 2.27 4.349H64.7l-.043-.241a3.458 3.458 0 00-1.333-2.111c-.773-.588-1.739-.882-2.898-.882-1.561 0-2.845.535-3.851 1.605-1.006 1.07-1.51 2.527-1.51 4.373 0 1.862.504 3.344 1.51 4.447 1.006 1.102 2.274 1.653 3.803 1.653a5.11 5.11 0 003.115-1.016c.917-.678 1.376-1.466 1.376-2.365 0-.277-.076-.494-.23-.649-.152-.155-.366-.233-.64-.233h-3.428V8.134h4.491l.224.008c.663.049 1.244.315 1.744.8.556.54.833 1.21.833 2.01v6.394h-2.849v-2.72l-.095.237c-.337.772-.897 1.4-1.68 1.883-.861.53-1.855.796-2.982.796-2.286 0-4.234-.768-5.843-2.303C52.805 13.704 52 11.548 52 8.77s.821-4.933 2.463-6.468C56.105.768 58.1 0 60.45 0zm23.181 4.802c1.851 0 3.372.6 4.564 1.8 1.19 1.201 1.787 2.724 1.787 4.57s-.596 3.373-1.787 4.581c-1.192 1.193-2.713 1.789-4.564 1.789s-3.377-.6-4.576-1.8c-1.2-1.201-1.799-2.724-1.799-4.57s.6-3.369 1.8-4.57c1.198-1.2 2.724-1.8 4.575-1.8zm36.992 0c1.369 0 2.467.453 3.296 1.36.83.906 1.244 2.086 1.244 3.54v7.644h-2.97v-7.007l-.007-.25c-.042-.736-.273-1.343-.693-1.82-.467-.531-1.079-.797-1.835-.797-.837 0-1.518.294-2.04.882-.524.588-.786 1.34-.786 2.254v6.738h-2.97V4.998h2.97v1.91l.105-.195c.725-1.274 1.954-1.911 3.686-1.911zm-8.813.196v12.348h-2.97V4.998h2.97zm-18.93 0l2.22 8.256 2.391-8.256h2.729l2.39 8.256 2.246-8.256h2.946l-3.864 12.348h-2.632L98.868 9.04l-2.463 8.306h-2.607L89.91 4.998h2.97zm-20.163 0v2.18l.105-.253c.29-.652.654-1.127 1.09-1.425.491-.335 1.13-.502 1.92-.502h1.424v2.523H75.35l-.173.005c-1.64.086-2.46 1.415-2.46 3.989v5.83h-2.97V4.999h2.97zm60.221 2.4c-.982 0-1.77.344-2.366 1.03-.596.686-.894 1.6-.894 2.744 0 1.143.298 2.058.894 2.744.595.686 1.384 1.029 2.366 1.029.998 0 1.8-.343 2.403-1.03.603-.685.905-1.6.905-2.743 0-1.143-.302-2.058-.905-2.744-.604-.686-1.405-1.03-2.403-1.03zm-49.307 0c-1.014 0-1.831.352-2.45 1.054-.62.703-.93 1.61-.93 2.72s.31 2.017.93 2.72c.619.702 1.436 1.053 2.45 1.053.998 0 1.807-.351 2.427-1.054.62-.702.93-1.608.93-2.72 0-1.11-.31-2.016-.93-2.719-.62-.702-1.429-1.053-2.427-1.053zM111.908.197v2.989h-3.188V.196h3.188z"
          ></path>
        </svg>
        <span class="sr-only"> Homepage </span>
      </a>
    </div>
  </footer>
  </div>
</template>
<script>

// form config
import personalFields from "/config/personalfields.json";

// components
import TextInput from "@/components/form/input/TextInput.vue";
import TextArea from "@/components/form/input/TextArea.vue";
import Checkbox from "@/components/form/input/Checkbox.vue";
import RadioInput from "@/components/form/input/RadioInput.vue";
import SelectInput from "@/components/form/input/SelectInput.vue";
import CheckboxGroupWorkDays from "@/components/form/input/CheckboxGroupWorkDays.vue";
import ConditionalTextInput from "@/components/form/input/ConditionalTextInput.vue";

export default {
  name: "Form",
  components: {
		TextInput,
    TextArea,
    RadioInput,
    Checkbox,
    CheckboxGroupWorkDays,
    SelectInput,
    ConditionalTextInput
  },
  data: function() {
    return {
      fields: { personalFields },
      valid: true,
      msg: '',
      copied: 0,
      fieldnames: {
        firstname: '',
        suffix: '',
        lastname: '',
        jobtitle: '',
        phone: '',
        email: '',
        workdays: ''
      }
    }
  },
  mounted: function () {

  },
  computed: {
    personalFieldsRows: function () {
      for (let [key, field] of Object.entries(this.fields.personalFields)) {
        if (field.exclude) delete this.fields.personalFields[key];
      }
      return this.fieldRows(this.fields.personalFields);
    }
  },
  methods: {
    indentHTML: function (html) {
      var tab = '\t';
      var result = '';
      var indent= '';

      html.split(/>\s*</).forEach(function(element) {
        if (element.match( /^\/\w/ )) {

          indent = indent.substring(tab.length);
        }

        result += indent + '<' + element + '>\r\n';

        if (element.match( /^<?\w[^>]*[^/]$/ ) && !element.startsWith("input")  ) {
          indent += tab;
        }
      });

      return result.substring(1, result.length-3);
    },
    allReplace : function(obj) {
        var retStr = this;
        for (var x in obj) {
            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
        }
        return retStr;
    },
    callback: function (event, fieldName) {
      for (var field in this.fieldnames) {
        if (fieldName.field) {
          if (field === fieldName.field.name) {
            this.fieldnames[field] = event ? event : ''
          }
        }

        if (field === fieldName) {
          this.fieldnames[field] = event ? event : ''
        }
      }
    },
    fieldRows: function (data = {}) {
      const rows = {};
      for (let field in data) {
        if (!data[field].group) rows[field] = [data[field]];
        else {
          if (!Array.isArray(rows[data[field].group])) rows[data[field].group] = [];
          rows[data[field].group].push(data[field]);
        }
      }
      return rows;
    },
    SelectText() {
        var doc = document
            , text = this.$refs.element
            , range, selection
        ;
        if (doc.body.createTextRange) {
            range = document.body.createTextRange();
            range.moveToElementText(text);
            range.select();
        } else if (window.getSelection) {
            selection = window.getSelection();
            range = document.createRange();
            range.selectNodeContents(text);
            selection.removeAllRanges();
            selection.addRange(range);
            doc.execCommand("Copy");
        }
    },
    validate: function () {

      // innocent until proven guilty
      let valid = true;

      // iterate over the form parts
      for (let fieldpart in this.fields) {

        // iterate over the fields
        for (let field in this.fields[fieldpart]) {

          let data = this.fields[fieldpart][field]

          // the field field
          const fieldComp = this.$refs[data.name] || this.$refs.addressFields.$refs[data.name];

          // if this field doesnt exist continue
          if (!fieldComp) continue;

          // validate field
          const fieldIsValid = fieldComp.validate();

          // if guilty
          if (!fieldIsValid) {

            // see if this is first error
            if (valid) {

              // smoothly scroll to the field
              fieldComp.$refs.field.scrollIntoView({
                behavior: "smooth",
                block: "center"
              });

              // put field in focus
              fieldComp.$refs.field.focus({preventScroll: true});

              // charge guilty
              valid = false;
            }
          }
        }
      }
      // submit form when all is valid
      if (valid) {

        String.prototype.allReplace = function(obj) {
          var retStr = this;
          for (var x in obj) {
            retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
          }
          return retStr;
        }

        // Select and Copy signature
        this.SelectText()


        // create HTML maybe in future
        // navigator.clipboard.writeText(this.indentHTML(this.$refs.element.outerHTML.allReplace({'<!--v-if-->': ''})))


        this.copied = 1

        clearTimeout(this.debounce)
        this.debounce = setTimeout(() => {
          this.copied = 0
        }, 3000)
      }
    }
  }
};

</script>
